import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from "../assets/locales/en/translation.json";
import translationFR from "../assets/locales/fr/translation.json";
import translationIT from "../assets/locales/it/translation.json";
import translationES from "../assets/locales/es/translation.json";
import translationDE from "../assets/locales/de/translation.json";
import translationNL from "../assets/locales/nl/translation.json";
import translationPT from "../assets/locales/pt/translation.json";
import translationCY from "../assets/locales/cy/translation.json";

const resources = {
	en: {
		translation: translationEN
	},
	fr: {
		translation: translationFR
	},
	it: {
		translation: translationIT
	},
	es: {
		translation: translationES
	},
	de: {
		translation: translationDE
	},
	nl: {
		translation: translationNL
	},
	pt: {
		translation: translationPT
	},
	cy: {
		translation: translationCY
	}
};

const savedLanguage = localStorage.getItem('selectedLanguage');
let initialLanguage = 'en';

if (savedLanguage) {
	try {
		const parsedLanguage = JSON.parse(savedLanguage);
		if (parsedLanguage && parsedLanguage.langCode) {
			initialLanguage = parsedLanguage.langCode;
		}
	} catch (e) {
		console.error('Failed to parse saved language', e);
	}
}

i18n
	.use(initReactI18next)
	.init({
		resources,
		lng: initialLanguage,
		fallbackLng: 'en',
		debug: false,
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: false
		},
		defaultNS: 'translation',
		load: 'languageOnly',
		detection: {
			order: [],
			lookupLocalStorage: 'i18nextLng'
		}
	});

i18n.on('languageChanged', (lng) => {
	const language = resources[lng] ? lng : 'en';

	const languageObject = {
		langCode: language,
		name: getLanguageName(language),
		img: getLanguageFlag(language)
	};

	localStorage.setItem('selectedLanguage', JSON.stringify(languageObject));
});

function getLanguageName(langCode) {
	const names = {
		en: 'english',
		fr: 'french',
		es: 'spanish',
		it: 'italian',
		de: 'german',
		nl: 'dutch',
		pt: 'portuguese_brazil',
		cy: 'welsh'
	};
	return names[langCode] || 'english';
}

function getLanguageFlag(langCode) {
	const flags = {
		en: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-uk-round.svg",
		fr: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-france-round.svg",
		es: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-spain-round.svg",
		it: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-italy-round.svg",
		de: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-germany-round.svg",
		nl: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-netherlands-round.svg",
		pt: "https://d2lxkizvrhu4im.cloudfront.net/icons/flag-of-brazil-round.svg",
		cy: "https://mereos-corder.s3.eu-west-3.amazonaws.com/library_icons/flag-of-whales-round.svg"
	};
	return flags[langCode] || flags.en;
}

export default i18n;